export const defaultSettings = {
    project_id: null,
    has_settings: true,
      default_weights: {
       headline: 2.0,
       first_paragraph: 1.5,
       rest_of_text: 1,
       headline_and_content: 0
    },
    mapping: {
      high_upper_limit: 8,
      medium_upper_limit: 3,
      low_upper_limit: 1.25,  
    },
    sections: {
      headline: [],
      first_paragraph: [],
      rest_of_text: [],
      headline_and_content: []
    }
};

export const relevancyMappingDefaultLimit = { 
  high_upper_limit: 8, 
  medium_upper_limit: 3, 
  low_upper_limit: 1.25 
}

export const relevancyMappingDefaultOptions = [
  {label: 'Critical', value: {'critical': relevancyMappingDefaultLimit.high_upper_limit}},
  {label: 'High', value: {'high': relevancyMappingDefaultLimit.high_upper_limit}},
  {label: 'Medium', value: {'medium': relevancyMappingDefaultLimit.medium_upper_limit}},
  {label: 'Low', value: {'low': relevancyMappingDefaultLimit.low_upper_limit}}
];

export const relevancyTypes = [
  { label: 'relevancy.scope.Default', value: 'Default', color: '#7f7777' },
  { label: 'relevancy.scope.RTA', value: 'RTA', color: '#3366ff' },
  { label: 'relevancy.scope.Coding', value: 'Coding', color: '#0896c2' },
  { label: 'relevancy.scope.ER', value: 'ER', color: '#10B981' },
  { label: 'relevancy.scope.Social', value: 'Social', color: '#998f6e' },
  { label: 'relevancy.scope.Curation', value: 'Curation', color: '#b097fc' }
]